import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommanServiceService {

  constructor() { }
  
  private sharedData: Subject<any> = new Subject<any>();
  sharedData$: Observable<any> = this.sharedData.asObservable();
sendSelectedId(id: any) {
    this.sharedData.next(id)

;
}
private isSidebarCollapsed = new BehaviorSubject<boolean>(false);
isSidebarCollapsed$ = this.isSidebarCollapsed.asObservable();

toggleSidebar() {
  this.isSidebarCollapsed.next(!this.isSidebarCollapsed.value);
}
}
